var module = angular.module('octopusApp.infrastructure');

// Manages who the current user is
module.factory('octopusAuthenticator', function ($state, octopusFeatures) {

    function setCurrentPrincipal(user, permissionSet) {
        Octopus.App.currentUser = user;
        Octopus.App.currentPermissionSet = permissionSet;
    }

    function logOut() {
        setCurrentPrincipal(null, null);
        octopusFeatures.clear();
        Octopus.Client.Util.ajax.cache.clearAll();
        $state.go("app.signin");
    }

    function currentUser(newValue) {
        if (typeof (newValue) !== "undefined") {
            Octopus.App.currentUser = newValue;
            Octopus.App.currentPermissionSet = null;
        }

        if (typeof (Octopus.App.currentUser) === "undefined") {
            return null;
        }

        return Octopus.App.currentUser;
    }

  return {
    currentUser: currentUser,
    setCurrentPrincipal: setCurrentPrincipal,
    logOut: logOut
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octopus_authenticator.js
// module id = 2479310901385024
// module chunks = 1